<template>
  <div class="flex-row" style="overflow:hidden;" :style="`width: ${width}px; height: ${height}px;`">
    <c-img :src="`/thumb/${tSize(f, width)}/${f.id}`" class="c-trn c-img" :style="`width: 100%; ${calcRotate(f)}`" />
  </div>
</template>

<script>
export default {
  props: {
    f: { type: Object, required: true },
    width: { type: Number, retuired: true },
    height: { type: Number, retuired: true },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    calcRotate: function(f) {
      return `transform:rotate(${f.rotate}deg)`;
    },
    tSize(f, w) {
      let upperMin = null;
      let lowerMax = null;
      for (const k of Object.keys(f.thumb_wh)) {
        const v = f.thumb_wh[k];
        if (w <= v[0]) {
          if (!upperMin || v[0] < f.thumb_wh[upperMin][0]) upperMin = k;
        } else {
          if (!lowerMax || v[0] > f.thumb_wh[lowerMax][0]) lowerMax = k;
        }
      }
      return upperMin || lowerMax || 'l';
    },
  },
};
</script>
